module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Regional-Landing-Page-w720.f0cfcd51.webp";